export default __webpack_public_path__ + "static/media/AccessibilityFrench.8f737419.pdf";